/**
 * Small static hub-and-spoke mark used on the homepage Work strip.
 * Breathing hub plus travelling packets, reduced-motion safe.
 */
export function HubMark({ className = "" }: { className?: string }) {
  const nodes = [
    { x: 120, y: 26, delay: 0.2 },
    { x: 214, y: 90, delay: 1.3 },
    { x: 120, y: 154, delay: 2.4 },
    { x: 26, y: 90, delay: 3.5 },
  ];

  return (
    <svg
      viewBox="0 0 240 180"
      role="img"
      aria-label="A hub connected to four nodes"
      className={`h-auto w-full max-w-[280px] ${className}`}
    >
      {nodes.map((n) => (
        <line
          key={`${n.x}-${n.y}`}
          x1={120}
          y1={90}
          x2={n.x}
          y2={n.y}
          stroke="hsl(var(--accent))"
          strokeOpacity={0.28}
          strokeWidth={1}
        />
      ))}

      {nodes.map((n) => (
        <g key={`pk-${n.x}-${n.y}`} className="work-packets">
          {[
            { path: `M120,90 L${n.x},${n.y}`, dur: "4.6s" },
            { path: `M${n.x},${n.y} L120,90`, dur: "5.4s" },
          ].map((p, dir) =>
            [0, 1].map((trail) => (
              <circle
                key={`${dir}-${trail}`}
                r={trail ? 1.4 : 2}
                fill="hsl(var(--accent))"
                fillOpacity={trail ? 0.3 : 0.85}
              >
                <animateMotion
                  dur={p.dur}
                  repeatCount="indefinite"
                  path={p.path}
                  begin={`-${n.delay + trail * 0.14}s`}
                  calcMode="linear"
                />
              </circle>
            )),
          )}
        </g>
      ))}

      {nodes.map((n) => (
        <circle
          key={`c-${n.x}-${n.y}`}
          cx={n.x}
          cy={n.y}
          r={11}
          fill="hsl(var(--card))"
          stroke="hsl(var(--accent))"
          strokeOpacity={0.55}
          strokeWidth={1}
        />
      ))}
      <circle
        cx={120}
        cy={90}
        r={26}
        className="work-hub-breathe"
        fill="hsl(var(--accent) / 0.12)"
        stroke="hsl(var(--accent))"
        strokeOpacity={0.75}
        strokeWidth={1.5}
      />
      <circle cx={120} cy={90} r={5} fill="hsl(var(--accent))" />
    </svg>
  );
}
